__turbopack_context__.v({
  "arrow": "Tooltip-module__2vjsta__arrow",
  "content": "Tooltip-module__2vjsta__content",
  "tooltip-in": "Tooltip-module__2vjsta__tooltip-in",
});
